function isNavVisible(nav) {
	var isOpen = false;
	var els = document.querySelectorAll(nav);
	for (var x = 0; x < els.length; x++)
		els[x].style.display != 'none' ? isOpen = true : false;
	// console.log('Function output: ' + isOpen);
	return isOpen;
}

var nav = '#menu-products, #menu-services, #menu-search, #menu-global';
var header = document.querySelector("nav");
var options = {
	onUnpin: function() {
		if ( isNavVisible(nav) ) {
			// console.log('A menu is open.');
			this.elem.classList.remove(this.classes.unpinned);
			this.elem.classList.add(this.classes.pinned);
		} else {
			// console.log('No menus are open.');
			this.elem.classList.add(this.classes.unpinned);
			this.elem.classList.remove(this.classes.pinned);
		}
	},
	tolerance: {
		down : 30,
		up : 0
	},
	offset : 80,
};

(function() {
	var headroom = new Headroom(header, options);
	headroom.init(); 
}());